import { cn } from "../lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-muted", className)} {...props} />;
}

function SkeletonLine({
  width = "75%",
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { width?: string }) {
  return (
    <Skeleton style={{ width, height: 12 }} className={cn("rounded-sm", className)} {...props} />
  );
}

function SkeletonBlock({
  height = 64,
  width = "100%",
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { height?: number; width?: string }) {
  return <Skeleton style={{ height, width }} className={cn(className)} {...props} />;
}

const AVATAR_SIZES = { sm: 24, md: 32, lg: 40 } as const;

function SkeletonAvatar({
  size = "md",
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { size?: keyof typeof AVATAR_SIZES }) {
  const px = AVATAR_SIZES[size];
  return (
    <Skeleton
      style={{ width: px, height: px }}
      className={cn("rounded-full shrink-0", className)}
      {...props}
    />
  );
}

export { Skeleton, SkeletonLine, SkeletonBlock, SkeletonAvatar };
